//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import styled from 'styled-components';

import Chip from '@components/atoms/chip/Chip';
import BodyLabelText from '@components/atoms/stat-bubble/BodyLabelText';
import StatBubbleSheet from '@components/atoms/stat-bubble/StatBubbleSheet';
import { mediaOrDataCardMixin } from '@components/reports/ReportSharedUI';

export const StyledStatBubbleSheet = styled(StatBubbleSheet)<{
  $isExportReport: boolean;
}>(
  ({ $isExportReport }) =>
    /*
     * This is needed to work around the quirk with rendering box-shadows
     * On the Preview app and some PDF readers box-shadows are rendering as thick borders
     */
    $isExportReport && mediaOrDataCardMixin,
);

export const StyledBodyLabelText = styled(BodyLabelText)(
  ({ theme }) => `
  padding-bottom: ${theme.spacings[1]};
`,
);

export const StatContainer = styled.div(
  () => `
    display: flex;
    align-items: center;
  `,
);

export const ChipContainer = styled.div`
  display: inline-block;
`;

export const StyledChip = styled(Chip)(
  ({ theme }) => `
  margin-left: ${theme.spacings[2]};
`,
);

export const LoadingShimmerWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  // Height is the calculated line height value for StatText
  height: 36px;
`;
